/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { TemplateSection } from './TemplateSection';
import {
    TemplateSectionFromJSON,
    TemplateSectionFromJSONTyped,
    TemplateSectionToJSON,
    TemplateSectionToJSONTyped,
} from './TemplateSection';

/**
 * 
 * @export
 * @interface TemplateVersionResponse
 */
export interface TemplateVersionResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    templateId?: string;
    /**
     * 
     */
    versionNumber?: number;
    /**
     * 
     */
    status?: TemplateVersionResponseStatusEnum;
    /**
     * 
     */
    publishedAt?: string;
    /**
     * 
     */
    publishedBy?: string;
    /**
     * 
     */
    changelog?: string;
    /**
     * 
     */
    sections?: Array<TemplateSection>;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const TemplateVersionResponseStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Archived: 'ARCHIVED',
} as const;
export type TemplateVersionResponseStatusEnum = typeof TemplateVersionResponseStatusEnum[keyof typeof TemplateVersionResponseStatusEnum];


/**
 * Check if a given object implements the TemplateVersionResponse interface.
 */
export function instanceOfTemplateVersionResponse(value: object): value is TemplateVersionResponse {
    return true;
}

export function TemplateVersionResponseFromJSON(json: any): TemplateVersionResponse {
    return TemplateVersionResponseFromJSONTyped(json, false);
}

export function TemplateVersionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateVersionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'versionNumber': json['versionNumber'] == null ? undefined : json['versionNumber'],
        'status': json['status'] == null ? undefined : json['status'],
        'publishedAt': json['publishedAt'] == null ? undefined : json['publishedAt'],
        'publishedBy': json['publishedBy'] == null ? undefined : json['publishedBy'],
        'changelog': json['changelog'] == null ? undefined : json['changelog'],
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(TemplateSectionFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function TemplateVersionResponseToJSON(json: any): TemplateVersionResponse {
    return TemplateVersionResponseToJSONTyped(json, false);
}

export function TemplateVersionResponseToJSONTyped(value?: TemplateVersionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'templateId': value['templateId'],
        'versionNumber': value['versionNumber'],
        'status': value['status'],
        'publishedAt': value['publishedAt'],
        'publishedBy': value['publishedBy'],
        'changelog': value['changelog'],
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(TemplateSectionToJSON)),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

